import { PageTypes } from '@sironamedical/common';
import { AppRoutePath } from 'config/constants';
import { matchPath, PathMatch } from 'react-router-dom';

export const RELEVANT_APP_ROUTES: Record<string, AppRoutePath[]> = {
  [PageTypes.VIEWER]: [AppRoutePath.VIEWER, AppRoutePath.VIEWER_BLANK],
  [PageTypes.REPORTER]: [AppRoutePath.REPORTER, AppRoutePath.REPORTER_BLANK],
  [PageTypes.PATIENT_JACKET]: [
    AppRoutePath.PATIENT_JACKET_UNDOCKED,
    AppRoutePath.PATIENT_JACKET_BLANK,
  ],
  [PageTypes.AI_SANDBOX]: [AppRoutePath.AI_SANDBOX, AppRoutePath.AI_SANDBOX_BLANK],
};

export const matchPaths = (
  type: PageTypes,
  basePath: string,
  opts?: { end?: boolean }
): PathMatch<string> | null => {
  if (!RELEVANT_APP_ROUTES[type]) {
    return null;
  }

  for (const path of RELEVANT_APP_ROUTES[type]) {
    const match = matchPath({ path, end: opts?.end ?? true }, basePath);
    if (match != null) {
      return match;
    }
  }
  return null;
};
